// @flow

import React from "react";
import type {Product} from "../../../models/Product";
import {currencyConverter} from "../../../helper/currency";
import "./NscGridPrice.scss";
import PickupLocationContainer from "../../../container/pickupLocation/PickupLocationContainer";
import {determineDistributionChannelForPriceDisplay} from "../../../models/Product";

export type NscGridPriceProps = {
    t: any,
    product: Product,
    showPrice: boolean,
    needsPickupLocation: boolean,
}


const NscGridPrice = (props: NscGridPriceProps) => {
    const {product, showPrice, needsPickupLocation} = props;
    const {distributionChannels, unitPrice} = product;

    const isMountingOnly = distributionChannels.mounting && !distributionChannels.shipping && !distributionChannels.pickup;
    const distChannel = determineDistributionChannelForPriceDisplay(product);
    const price = distChannel?.price;
    const recommendedRetailPrice = distChannel?.recommendedRetailPrice;

	return (
		<div className="hpm-gridPriceBox hpm-nscGridPriceBox">
			{(showPrice && needsPickupLocation && isMountingOnly)
				? (<div className="hpm-price">
						<PickupLocationContainer linkLabel={props.t("location.headline")}
												 classNames={"gridLocationSelect"}
												 linkStyle={{
													 display: "flex",
													 width: "100%",
													 justifyContent: "flex-end",
													 fontSize: "0.85rem",
													 whiteSpace: "nowrap"
												 }}
												 redirectToOverview={true}
						/>
					</div>
				)
				: (showPrice && (
					<div className={"hpm-price"}>
                        {price ?
                            <>
                                <span className={"price-label"}>{props.t("productDetailNSC.price")}</span>
                                <span className={"price-value"}>{currencyConverter(price)}</span>
                            </>
                            : <span className={"price-value"}>{props.t("productDetail.priceOnRequest")}</span>
                        }
					</div>
				)
			)}
			{price && unitPrice && (
				<div className="unit-price">
					<small>
						({currencyConverter(unitPrice.pricePerUnit)} / {unitPrice.measuringUnit === "sqm" ? "m²" : unitPrice.measuringUnit === "cbm" ? "m³" : unitPrice.measuringUnit})
					</small>
				</div>
			)}
			{recommendedRetailPrice && (
				<div className="hpm-retailPrice">
					<span className="retail-label">{props.t("productDetailNSC.originalRRP")}</span>
					<span className="retail-value">{recommendedRetailPrice && currencyConverter(recommendedRetailPrice)}</span>
				</div>
			)}
        </div>
    );
}

export default NscGridPrice;
